import { createAbsoluteFromTokens, PathToken, PathTokens } from "../../../../Common/ModelPath/ModelPath";
import { CalculationsBuilder } from "../../Engine/Core/Calculator2/AutoCalculations/CalculationsBuilder";
import { CalculationFunction } from "../../Engine/Core/Calculator2/AutoCalculations/CalculationFunction";
import { Expressions } from "../../Engine/Core/Calculator2/AutoCalculations/Expressions";
import { KCCondition } from "../../Engine/Core/Calculator2/Validations/KCCondition";
import { ValidationFunction } from "../../Engine/Core/Calculator2/Validations/ValidationFunction";
import { IForm } from "../../Engine/Form/IForm";
import { AutocalculationConfigurator } from "../FormResources";
import { DependenciesRequiredAreEmpty } from "../../Engine/Core/Calculator2/Validations/DependenciesRequiredAreEmpty";
import { KCCalculation } from "../../Engine/Core/Calculator2/AutoCalculations/KCCalculation";
import { KCSumCalculation } from "../../Engine/Core/Calculator2/AutoCalculations/KCSumCalculation";
import { KCCountCalculation } from "../../Engine/Core/Calculator2/AutoCalculations/KCCountCalculation";
import { KCLangRuntimeUtils } from "../../../../Common/KCLangRuntimeUtils";

export function loadCalculator2Resources(
    form: IForm,
    autocalculationConfigurators: undefined | AutocalculationConfigurator[]
): void {
    if (autocalculationConfigurators != undefined) {
        const builder = new CalculationsBuilder();
        for (const autocalculationConfigurator of autocalculationConfigurators) {
            autocalculationConfigurator({
                form: form,
                Expressions: Expressions,
                CalculationFunction: CalculationFunction,
                ValidationFunction: ValidationFunction,
                PathTokens: PathTokens,
                builder: builder,
                KCCondition: KCCondition,
                KCCalculation: KCCalculation,
                DependenciesRequiredAreEmpty: DependenciesRequiredAreEmpty,
                ap: (path: PathToken[]) => createAbsoluteFromTokens(path),
                KCSumCalculation: KCSumCalculation,
                KCCountCalculation: KCCountCalculation,
                kcLangUtils: new KCLangRuntimeUtils(),
            });
        }
        builder.applyTo(form.calculator2);
    }
}
